/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import CLog from '../../ComponentLogger';
import MutatorComponentBase from './MutatorComponentBase';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class AtlasMutator extends MutatorComponentBase
{
    @property()
    public get Execute(): boolean { return false; }
    public set Execute(value: boolean)
    {
        if (!top || this.atlases.length < 1)
        {
            CLog.error('Invalid setup.');
            return;
        }

        this.fillSpriteFrameMap();
        this.execute(this.top, [this.spriteHandler.bind(this)]);
    }

    @property({ type: cc.Node })
    protected top: cc.Node = null;

    @property([cc.SpriteAtlas])
    protected atlases: cc.SpriteAtlas[] = [];

    private _spriteFrameMap: Map<string, cc.SpriteFrame> = null;

    private spriteHandler(target: cc.Node): boolean
    {
        if (!this.atlases) { return; }

        let success: boolean = false;
        let sprite: cc.Sprite = target.getComponent(cc.Sprite);

        if (!sprite) { return false; }

        if (!sprite.spriteFrame)
        {
            this.error(sprite.node, 'No sprite frame.');
            return false;
        }

        let atlasFrame: cc.SpriteFrame = this._spriteFrameMap.get(this.getSpriteFrameKey(sprite.spriteFrame));
        if (!atlasFrame)
        {
            this.error(target, `Not atlassed, MISSING.`);
            return false;
        }

        if (atlasFrame.getTexture().url !== sprite.spriteFrame.getTexture().url)
        {
            this.warn(target,  `Not correctly atlassed.`);
            if (this.shouldModify)
            {
                this.syncSpriteFrame(sprite, atlasFrame);
                this.warn(target,  `Atlas texture url set.`);
            }
            success = true;
        }

        return success;
    }

    private syncSpriteFrame(sprite: cc.Sprite, atlasFrame: cc.SpriteFrame): void
    {
        atlasFrame.insetTop = sprite.spriteFrame.insetTop;
        atlasFrame.insetRight = sprite.spriteFrame.insetRight;
        atlasFrame.insetBottom = sprite.spriteFrame.insetBottom;
        atlasFrame.insetLeft = sprite.spriteFrame.insetLeft;

        sprite.spriteFrame = atlasFrame;
    }

    private fillSpriteFrameMap(): void
    {
        this._spriteFrameMap = new Map();

        for (let atlas of this.atlases)
        {
            let frames: cc.SpriteFrame[] = atlas.getSpriteFrames();

            for (let frame of frames)
            {
                let key: string = this.getSpriteFrameKey(frame);
                this._spriteFrameMap.set(key, frame);
            }
        }
    }

    private getSpriteFrameKey(frame: cc.SpriteFrame): string
    {
        let texture: cc.Size = frame.getOriginalSize();
        return `${frame.name}:${texture.width}:${texture.height}`;
    }
}
